export enum MissingCalculationParam {
    CAR_REGISTRATION_NUMBER = 'CAR_REGISTRATION_NUMBER',
    FIRST_NAME = 'FIRST_NAME',
    LAST_NAME = 'LAST_NAME',
    PESEL = 'PESEL',
}
